import type { PaymentOrder } from '@/features/veluvit/schemas/payment.schema'

export const PAYMENT_STATUS_LABELS: Record<PaymentOrder['status'], string> = {
  pending: '결제 확인 중',
  awaiting_deposit: '입금 대기',
  paid: '결제 완료',
  partially_refunded: '부분 환불',
  refunded: '환불 완료',
  failed: '결제 실패',
}

export function paymentMethodLabel(order: PaymentOrder) {
  const labels: Record<string, string> = {
    CARD: '신용·체크카드',
    TRANSFER: '계좌이체',
    VIRTUAL_ACCOUNT: '가상계좌',
    MOBILE_PHONE: '휴대폰',
    BANK: '계좌이체',
    VACNT: '가상계좌',
    PHONE: '휴대폰',
  }
  return (
    order.payment.easyPayName ||
    labels[order.payment.payMethod] ||
    '결제수단 확인 중'
  )
}

export function isCheckoutInterrupted(order: PaymentOrder) {
  return order.status === 'pending' && order.payment.phase === 'checkout_failed'
}
